import { Flex, VStack } from '@chakra-ui/react'
import { useCurrentUser } from '@src/hooks/useCurrentUser'
import React from 'react'

type AccountAsideProps = {}

export const OnboardingAside = (props: AccountAsideProps) => {
  const { currentUser } = useCurrentUser()

  return (
    <VStack width={'full'}>
      <Flex
        align={'stretch'}
        height={'full'}
        justify={'stretch'}
        padding={0}
        width={'full'}
        dangerouslySetInnerHTML={{
          __html: `<iframe
          className="airtable-embed"
          src="https://airtable.com/embed/appGac7xqFM0E3j1I/pagLqW44IYD6e5M5t/form?prefill_Reporter_Name=${currentUser?.fullName}&prefill_Reporter_Email=${currentUser?.email}"
          frameBorder="0"
          onmousewheel=""
          style="background: transparent; border: 1px solid #ccc;width: 100%;height: 100%;border-radius: 8px"
        ></iframe>`,
        }}
      />
    </VStack>
  )
}
